import React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CircularProgress from "@mui/material/CircularProgress";

export interface SearchInputProps extends Omit<TextFieldProps, "type"> {
  loading?: boolean;
}

const SearchInput = ({
  loading = false,
  placeholder = "Search...",
  label = "Search",
  variant = "outlined",
  fullWidth = true,
  InputProps,
  ...rest
}: SearchInputProps) => {
  return (
    <TextField
      // type="search"
      label={label}
      variant={variant}
      fullWidth={fullWidth}
      placeholder={placeholder}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        ...InputProps,
      }}
      {...rest}
    />
  );
};

export default SearchInput;
